import styles from './ButtonHero.module.scss'

/**
 * ButtonHero
 *
 * Reusable action button for the Hero section (VisualizationView, ModelView).
 * Positioned absolutely by the parent — this component handles only
 * internal appearance (background, text, sizing, hover state).
 *
 * Props:
 *   onClick   — required click handler
 *   children  — button label / content
 *   className — optional extra class from parent (positioning, variant override)
 *   stretch   — when true, lets the button fill available horizontal space
 */
export function ButtonHero({ onClick, children, className, stretch = false, style, ...rest }) {
  const cls = [styles.root, className].filter(Boolean).join(' ')
  return (
    <button
      type="button"
      className={cls}
      onClick={onClick}
      style={stretch ? { ...style, width: '100%', flex: '1 1 0' } : style}
      {...rest}
    >
      {children}
    </button>
  )
}
